import Swal from "sweetalert2";

export const alert = ({ title, text, icon, confirmButtonColor, onConfirm }) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "Ok",
    confirmButtonColor: confirmButtonColor,
  }).then(() => {
    if (onConfirm) {
      onConfirm();
    }
  });
};
